<template>
  <div>
    <!-- First page is visible for all Uitkerende offers and for ATP+ and their clients -->
    <div
      class="card"
      v-if="
        Number(offerType) !== 2
        && Number(offerType) !== 3
        && offerTypeShort === 'uitkerend'
      "
    >
      <div class="print">
        <img class="db-logo" src="../../../assets/db/DB-logo1.svg" />

        <h2 class="title">Direct profijt of later meer uitkeren?</h2>
        <p v-if="Number(offerType) === 1 || Number(offerType) === 4" style="line-height: 150%">
          <!-- Text for Hoge aanvang -->
          Deze uitkerende beleggingslijfrente bij Doelbeleggen.nl is zo samengesteld dat er wordt
          gestart met een hogere uitkering die daarna zelfs nog wat oploopt. Daardoor sluit deze
          beter aan bij uw behoefte om in het begin van uw pensioen hogere uitkeringen te
          ontvangen. De traditionele beleggingslijfrente doet dat niet. Die begint laag en loopt
          op, om pas jaren later op hetzelfde niveau te komen. Als het past bij uw situatie kunnen
          wij ook een beleggingslijfrente aanbieden met een normale aanvang.
          <br /><br />
        </p>
        <p
          v-else-if="Number(offerType) === 0 || Number(offerType) === 5"
          style="line-height: 150%"
        >
          <!--Text for Normale aanvang -->
          Deze uitkerende beleggingslijfrente bij Doelbeleggen.nl is zo samengesteld dat er wordt
          gestart met een relatief lage uitkering die, afhankelijk van het beleggingsresultaat,
          naar verwachting zal stijgen. Als het past bij uw situatie kunnen wij ook een
          beleggingslijfrente met een hoge aanvang aanbieden.
          <br /><br />
        </p>

        <div class="graph" v-if="duration != 5 && [0, 1, 4, 5].includes(Number(offerType))">
          <GChart
            :settings="{ packages: ['corechart'], language: 'nl-nl' }"
            :data="[columns].concat(calculation.charts.chart2)"
            :options="options"
            type="ComboChart"
          />
        </div>

        <p style="line-height: 150%">
          In bovenstaande grafiek wordt gerekend met een netto voorbeeldrendement van
          {{ rendement }}%.
          Periodiek berekenen we de hoogte van uw nieuwe uitkering. Dat doen we in ieder geval
          elk jaar op basis van gerealiseerd resultaat. Dit houdt in dat uw uitkeringen jaarlijks
          kunnen afwijken van de bovenstaande grafiek<sup>*</sup>.
        </p>
        <template v-if="Number(offerType) === 1 || Number(offerType) === 4">
          <br />
          <p style="line-height: 150%">
            <b>Hoe werken de uitkeringen bij de hoge aanvang</b><br />
            Onze beleggingslijfrente met een hoge aanvang is samengesteld uit een combinatie van
            verschillende lijfrentes. Daar zitten ook tijdelijke lijfrentes bij. Dit is van belang
            wanneer uw situatie vereist dat u een 'levenslange' (20 jaar of langer) uitkering
            ontvangt. Ook geldt dat, indien u elders tijdelijke lijfrentes heeft of (nog) gaat
            afsluiten, u rekening moet houden met tijdelijke lijfrentes in uw lijfrente bij
            Doelbeleggen van {{offerType === 4 ? '' : 'bruto'}}
            <b>&euro; {{formatPrice(calculation.shortUnits, true)}},-</b>.
            <br /><br />
            Na het eerste jaar lopen de hoogte van de uitkeringen een
            aantal jaren op. Daarna zakken deze iets terug naar het niveau van het eerste jaar. Zo
            heeft u in de eerste jaren, bij het aangenomen netto voorbeeldrendement, hogere
            uitkeringen dan wanneer u ouder bent.
            <br /><br />
            Natuurlijk doen we ons best om met uw beleggingen een resultaat van het
            voorbeeldrendement of hoger te halen. In dat geval kunnen we uw uitkering gemiddeld
            ongeveer gelijk houden of zelfs laten stijgen. Lukt dat niet, dan kan uw uitkering in
            de opvolgende jaren ook lager uitvallen.
          </p>
        </template>
        <br />

        <div class="docdate">
          {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
        </div>
        <div class="pagefooter">
          {{
            persoonsData.geslacht
              ? persoonsData.geslacht === 'man' ? 'de heer': 'mevrouw'
              : 'de heer/mevrouw'
          }}
          {{(persoonsData.roepnaam || persoonsData.voornaam) || '' }}
          {{ persoonsData.tussenvoegsel || '' }}
          {{ persoonsData.achternaam || '' }}
          <br />
          Indicatieve berekening {{ goalType }}
        </div>
        <div class="pagenumber" />
        <div class="break" />
      </div>
    </div>

    <!-- Second page is visible for all offers send -->
    <div class="card">
      <div class="print" style="overflow: auto">
        <img class="db-logo" src="../../../assets/db/DB-logo1.svg" />

        <template v-if="(atpData.connected || Number(role) === 2)">
          <h2 class="title">Kosten van dienstverlening en beleggen</h2>
          <p style="line-height: 150%">
            <!-- Customers from ATP+ and ATP+ -->
            Doelbeleggen.nl brengt kosten in rekening voor het beheer van uw portefeuille.
            In deze persoonlijke indicatieve berekening is gebruik gemaakt van rendement ná aftrek
            van kosten die verbonden zijn aan het beheer van uw portefeuille. Deze kosten (die in
            mindering zijn gebracht op het bruto rendement) kunt u nalezen in ons
            <a
              title="Klik hier om ons Kostenoverzicht te bekijken op onze website"
              style="text-decoration:underline;color:blue;"
              target="_blank"
              href="https://www.doelbeleggen.nl/content/uploads/Tarievenoverzicht.pdf"
            >
              Kostenoverzicht.
            </a>
            <br /><br />
            <template v-if="offerTypeShort === 'uitkerend'">
              <b>Uitvoering excasso</b>
              <br />
              Naast belegger van uw oudedagsvoorziening, zijn we ook de uitvoerder van de
              uitkeringen (Uitvoering excasso). Als uitvoerder van uw oudedagsvoorziening hebben we
              de nodige beheerwerkzaamheden. Fiscaal en juridisch moet gedurende de gehele looptijd
              alles kloppen. We maken van jaar tot jaar een berekening voor de nieuwe
              uitkering.
              <template v-if="offerType !== 4 && offerType !== 5">
                Net als uw werkgever bij uw loon deed, houden we op de uitkering
                loonheffing in. Dit gebeurt volgens de zgn. Groene tabel.
              </template>
              <template v-else>
                Net als uw werkgever verwerken wij uw uitkering via loonadministratie.
              </template>
              De kosten hiervoor zijn € 4,50 per uitkering en 0,25% per jaar over het vermogen en
              wordt per kwartaal in rekening gebracht.
              <br /><br />
            </template>
          </p>
          <h2 class="title">Disclaimer</h2>
          <p style="line-height: 150%">
            Deze indicatieve berekening is bedoeld om u inzicht te geven in de verwachting voor de
            komende jaren en de bijbehorende uitkeringen vanaf het moment dat u start met uitkeren
            (dit is nadrukkelijk geen beleggingsvoorstel- of advies).
          </p>
          <p style="line-height: 150%">
            <i>
              * De waarde van uw beleggingen
              {{ offerTypeShort === 'uitkerend'
                ? 'en de hoogte van uw uitkeringen kunnen'
                : 'kan'
              }}
              fluctueren. In het verleden behaalde resultaten bieden geen garantie voor de toekomst.
              Beleggen door wie en in welke vorm dan ook brengt altijd risico’s met zich mee. Zo
              kunt u (een deel van) uw ingelegde vermogen verliezen als gevolg van koersdalingen.
            </i>
          </p>
        </template>
        <template v-else>
          <h2 class="title">Kosten van dienstverlening en beleggen</h2>
          <p style="line-height: 150%">
              <b>Onze dienstverlening</b><br>
              Doelbeleggen.nl heeft een vaste beheervergoeding (Doorlopend) van 0,75% per jaar. Deze
              wordt per kwartaal in rekening gebracht. Daarnaast wordt een vergoeding van 0,10% over
              de transactiewaarde van een aan- of verkoop gerekend (Transacties). In het eerste jaar
              wordt de portefeuille volledig ingericht en bedragen deze dus 0,10% van uw inleg. In
              lopende jaren komen deze door herwegen en optimaliseren van de portefeuille neer op
              circa 0,02% per jaar. Bij de transactiekosten zijn zogenaamde 'spreadkosten' ook
              meegenomen. Dat zijn afwijkingen in de prijs ten opzichte van de middenprijs op de
              beurs. Om de kosten inzichtelijk te maken, hebben wij aannames gemaakt. Deze kosten
              zijn een indicatie. Bij het vermogensbeheer moeten we ook vergoedingen betalen aan
              anderen (Verwante diensten), zoals de kosten van toezichthouders (AFM en DNB) of
              eventuele belasting over transacties. Deze kosten berekenen wij aan u door en zijn
              circa 0,01% over het belegd vermogen.
              <br /><br />
              <template v-if="offerTypeShort === 'uitkerend'">
                <b>Uitvoering excasso</b>
                <br />
                Naast belegger van uw oudedagsvoorziening, zijn we ook de uitvoerder van de
                uitkeringen (Uitvoering excasso). Als uitvoerder van uw oudedagsvoorziening hebben
                we de nodige beheerwerkzaamheden. Fiscaal en juridisch moet gedurende de gehele
                looptijd alles kloppen. We maken van jaar tot jaar een berekening voor de
                nieuwe uitkering.
                <template v-if="offerType !== 4 && offerType !== 5">
                  Net als uw werkgever bij uw loon deed, houden we op de uitkering
                  loonheffing in. Dit gebeurt volgens de zgn. Groene tabel.
                </template>
                <template v-else>
                  Net als uw werkgever verwerken wij uw uitkering via loonadministratie.
                </template>
                De kosten hiervoor zijn
                € 4,50 per uitkering en 0,25% per jaar over het vermogen en wordt per kwartaal in
                rekening gebracht.
                <br /><br />
              </template>
              <b>Financiële instrumenten</b><br>
              We beleggen voor u in trackers. Wij ontwikkelen zelf geen trackers. Dat doen andere
              bedrijven. De kosten van deze bedrijven zitten in de koers van de trackers. Deze
              bestaan uit een management fee (Doorlopend) en transactie&shy;kosten (Transacties).
              U ziet deze kosten niet. Wij ook niet. Deze kosten zijn gemiddeld over de
              verschillende profielen, circa
              {{ formatPrice(simpleVKM.instruments.totalPercent()) }}% per jaar.
            </p>
            <br />
            <div style="overflow: auto">
              <table
                :class=" ['transparent-table-alternate', offerTypeShort]"
                v-if="vermogen > 9"
              >
                <tr>
                  <td><b>Inleg: &euro; {{ formatPrice(simpleVKM.startAmount) }}</b></td>
                  <td><b>&euro; Jaar 1</b></td>
                  <td><b>% Jaar 1</b></td>
                  <td><b>&euro; Volgende jaren</b></td>
                  <td><b> % Volgende jaren</b></td>
                </tr>
                <tr>
                  <td><b>Onze dienstverlening</b></td>
                </tr>
                <tr>
                  <td>Doorlopend</td>
                  <td>&euro; {{ formatPrice(simpleVKM.services.continuousCost()) }}</td>
                  <td>{{ formatPrice(simpleVKM.services.continuousPercent) }}%</td>
                  <td>&euro; {{ formatPrice(simpleVKM.services.continuousCost()) }}</td>
                  <td>{{ formatPrice(simpleVKM.services.continuousPercent) }}%</td>
                </tr>
                <tr>
                  <td>Transacties</td>
                  <td>&euro; {{ formatPrice(simpleVKM.services.transactionsCostYear1()) }}</td>
                  <td>{{formatPrice(simpleVKM.services.transactionsPercentYear1)}}%</td>
                  <td>&euro; {{ formatPrice(simpleVKM.services.transactionsCost()) }}</td>
                  <td>{{formatPrice(simpleVKM.services.transactionsPercent)}}%</td>
                </tr>
                <tr>
                  <td>Verwante diensten</td>
                  <td>&euro; {{ formatPrice(simpleVKM.services.servicesCost()) }}</td>
                  <td>{{formatPrice(simpleVKM.services.servicesPercent)}}%</td>
                  <td>&euro; {{ formatPrice(simpleVKM.services.servicesCost()) }}</td>
                  <td>{{formatPrice(simpleVKM.services.servicesPercent)}}%</td>
                </tr>
                <tr v-if="offerTypeShort === 'uitkerend'">
                  <td>Uitvoering excasso</td>
                  <td>&euro; {{formatPrice(simpleVKM.services.excassoCost)}}</td>
                  <td>{{formatPrice(simpleVKM.services.excassoPercent)}}%</td>
                  <td>&euro; {{formatPrice(simpleVKM.services.excassoCost)}}</td>
                  <td>{{formatPrice(simpleVKM.services.excassoPercent)}}%</td>
                </tr>
                <tr>
                  <th>Onze dienstverlening (totaal)</th>
                  <th>&euro; {{ formatPrice(simpleVKM.services.totalCostYear1()) }}</th>
                  <th>{{ formatPrice(simpleVKM.services.totalPercentYear1()) }}%</th>
                  <th>&euro; {{ formatPrice(simpleVKM.services.totalCost()) }}</th>
                  <th>{{ formatPrice(simpleVKM.services.totalPercent()) }}%</th>
                </tr>
                <tr>
                  <td><b>Financiële instrumenten</b></td>
                </tr>
                <tr>
                  <td>Doorlopend</td>
                  <td>&euro; {{ formatPrice(simpleVKM.instruments.continuousCost()) }}</td>
                  <td>{{formatPrice(simpleVKM.instruments.continuousPercent)}}%</td>
                  <td>&euro; {{ formatPrice(simpleVKM.instruments.continuousCost()) }}</td>
                  <td>{{formatPrice(simpleVKM.instruments.continuousPercent)}}%</td>
                </tr>
                <tr>
                  <td>Transacties</td>
                  <td>&euro; {{ formatPrice(simpleVKM.instruments.transactionsCost()) }}</td>
                  <td>{{formatPrice(simpleVKM.instruments.transactionsPercent)}}%</td>
                  <td>&euro; {{ formatPrice(simpleVKM.instruments.transactionsCost()) }}</td>
                  <td>{{formatPrice(simpleVKM.instruments.transactionsPercent)}}%</td>
                </tr>
                <tr>
                  <th>Financiële instrumenten (totaal)</th>
                  <th>&euro; {{ formatPrice(simpleVKM.instruments.totalCost()) }}</th>
                  <th>{{ formatPrice(simpleVKM.instruments.totalPercent()) }}%</th>
                  <th>&euro; {{ formatPrice(simpleVKM.instruments.totalCost()) }}</th>
                  <th>{{ formatPrice(simpleVKM.instruments.totalPercent()) }}%</th>
                </tr>
                <tr>
                  <th>Totaal</th>
                  <th>&euro; {{ formatPrice(simpleVKM.totalCostYear1()) }}</th>
                  <th>{{ formatPrice(simpleVKM.totalPercentYear1()) }}%</th>
                  <th>&euro; {{ formatPrice(simpleVKM.totalCost()) }}</th>
                  <th>{{ formatPrice(simpleVKM.totalPercent()) }}%</th>
                </tr>
              </table>
            </div>
        </template>
      </div>
      <div class="docdate">
        {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        {{
          persoonsData.geslacht
            ? persoonsData.geslacht === 'man' ? 'de heer': 'mevrouw'
            : 'de heer/mevrouw'
        }}
        {{(persoonsData.roepnaam || persoonsData.voornaam) || '' }}
        {{ persoonsData.tussenvoegsel || '' }}
        {{ persoonsData.achternaam || '' }}
        <br />
        Indicatieve berekening {{ goalType }}
      </div>
      <div class="pagenumber" />
      <div class="break" v-if="!(atpData.connected || Number(role) === 2)" />
    </div>

    <!-- Third page is visible for all offers send from admin and their clients -->
    <div class="card" v-if="!(atpData.connected || Number(role) === 2)">
      <div class="print">
        <img class="db-logo" src="../../../assets/db/DB-logo1.svg" />
        <h2 class="title">Disclaimer</h2>
        <p style="line-height: 150%">
          Deze indicatieve berekening is bedoeld om u inzicht te geven in de verwachting voor de
          komende jaren en de bijbehorende uitkeringen vanaf het moment dat u start met uitkeren
          (dit is nadrukkelijk geen beleggingsvoorstel- of advies).
        </p>

        <p style="line-height: 150%">
          <i>
            * De waarde van uw beleggingen
            {{
              offerTypeShort === 'uitkerend'
                ? 'en de hoogte van uw uitkeringen kunnen'
                : 'kan'
            }}
            fluctueren. In het verleden behaalde resultaten bieden geen garantie voor de toekomst.
            Beleggen door wie en in welke vorm dan ook brengt altijd risico’s met zich mee. Zo
            kunt u (een deel van) uw ingelegde vermogen verliezen als gevolg van koersdalingen.
          </i>
        </p>
      </div>
      <div class="docdate">
        {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        {{
          persoonsData.geslacht
            ? persoonsData.geslacht === 'man' ? 'de heer': 'mevrouw'
            : 'de heer/mevrouw'
        }}
        {{(persoonsData.roepnaam || persoonsData.voornaam) || '' }}
        {{ persoonsData.tussenvoegsel || '' }}
        {{ persoonsData.achternaam || '' }}
        <br />
        Indicatieve berekening {{ goalType }}
      </div>
      <div class="pagenumber" />
    </div>
    <div class="last-item"/>
  </div>
</template>

<script>
export default {
  props: {
    intakeAdmin: Object,
    atpData: Object,
    goalData: Object,
    persoonsData: Object,
    rendement: Number,
    duration: {
      type: Number,
      default: 10,
    },
    vermogen: {
      type: Number,
      default: 175000,
    },
    offerType: {
      type: Number,
      default: -1,
    },
    calculation: {
      type: Object,
    },
    profile: {
      type: String,
      default: 'C',
    },
    paymentPeriod: {
      type: String,
      default: 'Per maand',
    },
    today: {
      type: Date,
      default: () => new Date(),
    },
  },
  data() {
    return {
      options: {
        backgroundColor: { fill: 'transparent' },
        height: 300,
        legend: { position: 'top' },
        pointSize: 0,
        chartArea: {
          left: 65,
          top: 55,
          bottom: 40,
          right: 20,
          width: '100%',
          height: '100%',
        },
        hAxis: {
          title: 'Jaren',
          gridlines: { color: '#eee' },
          textStyle: { fontSize: 13 },
        },
        vAxis: {
          gridlines: { color: '#eee' },
          textStyle: { fontSize: 13 },
        },
        series: {
          0: {
            type: 'line', lineWidth: 0, visibleInLegend: false, tooltip: false,
          },
          1: { type: 'line', color: '#67bf00' },
          2: { type: 'line', color: '#000066' },
        },
      },
      columns: [
        {
          type: 'string',
          label: 'Jaar',
        },
        {
          type: 'number',
          label: 'U-Rendement',
        },
        {
          type: 'number',
          label: 'Hoge aanvang',
        },
        {
          type: 'number',
          label: 'Normale aanvang',
        },
      ],
    };
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    goalType() {
      if (this.goalData.type === 'gouden-handdruk-opbouwend' || this.goalData.type === 'gouden-handdruk-uitkerend') {
        return 'Gouden handdruk';
      }
      if (this.goalData.type === 'netto-lijfrente-uitkerend') {
        return 'Netto lijfrente';
      }
      return 'Lijfrente';
    },
    paymentTerms() {
      if (this.paymentPeriod === 'Per maand') {
        return 12;
      }
      if (this.paymentPeriod === 'Per kwartaal') {
        return 4;
      }
      if (this.paymentPeriod === 'Per halfjaar') {
        return 2;
      }
      return 1;
    },
    offerTypeShort() {
      if (
        this.goalData.type === 'gouden-handdruk-uitkerend'
        || this.goalData.type === 'netto-lijfrente-uitkerend'
        || (this.goalData.type === 'levensonderhoud' && this.goalData.box === '1')
      ) {
        return 'uitkerend';
      }
      return 'opbouwend';
    },
    simpleVKM() {
      const amount = this.vermogen;
      let excassoPercentage = 0.0025;
      if (this.intakeAdmin && this.intakeAdmin.feeName === 'dbuitkerendgeeneu') {
        excassoPercentage = 0.0050;
      }
      const excasso = this.offerTypeShort === 'uitkerend' ? amount * excassoPercentage + (4.5 * this.paymentTerms) : 0;
      const vkm = {
        startAmount: amount,
        totalCost() {
          return this.services.totalCost() + this.instruments.totalCost();
        },
        totalCostYear1() {
          return this.services.totalCostYear1() + this.instruments.totalCost();
        },
        totalPercentYear1() {
          return this.services.totalPercentYear1() + this.instruments.totalPercent();
        },
        totalPercent() {
          return this.services.totalPercent() + this.instruments.totalPercent();
        },
        services: {
          continuousPercent: 0.75,
          continuousCost() {
            return amount * (this.continuousPercent / 100);
          },
          transactionsPercentYear1: 0.19,
          transactionsCostYear1() {
            return amount * (this.transactionsPercentYear1 / 100);
          },
          transactionsPercent: 0.02,
          transactionsCost() {
            return amount * (this.transactionsPercent / 100);
          },
          servicesPercent: 0.01,
          servicesCost() {
            return amount * (this.servicesPercent / 100);
          },
          excassoCost: excasso,
          excassoPercent: (excasso / amount) * 100,
          totalCostYear1() {
            return this.continuousCost()
              + this.transactionsCostYear1()
              + this.servicesCost()
              + this.excassoCost;
          },
          totalCost() {
            return this.continuousCost()
              + this.transactionsCost()
              + this.servicesCost()
              + this.excassoCost;
          },
          totalPercentYear1() {
            return this.continuousPercent
            + this.transactionsPercentYear1
            + this.servicesPercent
            + this.excassoPercent;
          },
          totalPercent() {
            return this.continuousPercent
            + this.transactionsPercent
            + this.servicesPercent
            + this.excassoPercent;
          },
        },
        instruments: {
          continuousPercent: 0.17,
          continuousCost() {
            return amount * (this.continuousPercent / 100);
          },
          transactionsPercent: 0.02,
          transactionsCost() {
            return amount * (this.transactionsPercent / 100);
          },
          totalPercent() {
            return this.continuousPercent + this.transactionsPercent;
          },
          totalCost() {
            return this.continuousCost() + this.transactionsCost();
          },
        },
      };
      return vkm;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/_paper.scss";
h2 {
  margin-top: 30px;
  &:first-child {
    margin-top: 0;
  }
}
.transparent-table {
  tr {
    background-color: transparent;
  }
}
.transparent-table-alternate {
  tr {
    background-color: transparent;
  }
  tr:nth-child(2) {
    border-top: 1px solid $color-highlight;
  }
  tr:nth-child(3) {
    border: none;
  }
}
.opbouwend {
  tr:nth-child(6) {
    border-top: 1px solid $color-highlight;
  }
  tr:nth-child(7) {
    border: none;
  }
  tr:nth-child(10) {
    border-top: 1px solid $color-highlight;
  }
  tr:nth-child(11) {
    border-top: 2px solid $color-highlight;
  }
}
.uitkerend {
  tr:nth-child(7) {
    border-top: 1px solid $color-highlight;
  }
  tr:nth-child(8) {
    border: none;
  }
  tr:nth-child(11) {
    border-top: 1px solid $color-highlight;
  }
  tr:nth-child(12) {
    border-top: 2px solid $color-highlight;
  }
}

.last-item {
  @media #{$mobile} {
    padding-bottom: 2rem;
  }
}
</style>
